import { Injectable } from '@angular/core';
import * as moment from 'moment';
import { Moment } from 'moment';

interface Performance {
  pouringTimeReal: number;
  pouringTimePlanned: number;
  performance: number;
}

@Injectable({
  providedIn: 'root',
})
export class PouringPerformanceService {
  constructor() {}
  /*
   * [Calculate pouring performance time planned, pouring time real and pouring performance of loads]
   * @param  {[any]} dateUpdate [the principal selected date on screen]
   * @param  {[any]} loads [the loads to be processed]
   * @return {[Performance]}      [Returns the calculated values]
   */
  getPouringTimePlannedAndPouringTimeReal(dateUpdate: any, loads: any[]): Performance {
    let pouringTimePlanned = 0;
    let pouringTimeReal = 0;
    const onJobsiteRealDateTimeList = loads
      .map(({ onJobsiteRealDateTime }) => onJobsiteRealDateTime)
      .filter((date) => !!date && date !== '0001-01-01T00:00:00')
      .sort((a, b) => {
        if (a < b) {
          return -1;
        }
        if (a > b) {
          return 1;
        }
        return 0;
      });

    /*
     * ------------------|-------------------------|-------------------------------------|---------------------------
     * OnJobSitePlanned  | OnJobSiteReal           |       UnloadingEndPlanned           | UnloadingEndReal
     * ------------------|-------------------------|-------------------------------------|--------------------------
     * deliveryDateTime  | onJobsiteRealDateTime   |       (from last element)           | (from last element if is completed)
     *                   |                         | deliveryDateTime +  unloadingTime   | unloadingEndRealDateTime
     * */
    const firstOnJobSiteRealTime = onJobsiteRealDateTimeList[0];

    const lastElement = loads[loads.length - 1];

    const { unloadingTime, deliveryDateTime, unloadingEndRealDateTime } = lastElement;

    const unloadingEndPlanned: Moment = moment(deliveryDateTime).add(unloadingTime, 'minutes'); // should calculate
    // Calculate using unloadingEndPlanned - deliveryDateTime of header order
    const firstItem = loads[0];

    pouringTimePlanned = unloadingEndPlanned.diff(firstItem.deliveryDateTime, 'minutes');

    if (loads.every(({ unloadingEndRealDateTime: un }) => !!un && un.toString() !== '0001-01-01T00:00:00')) {
      pouringTimeReal = moment(unloadingEndRealDateTime).diff(firstOnJobSiteRealTime, 'minutes');
    } else {
      if (dateUpdate && firstOnJobSiteRealTime) {
        const updated = moment(dateUpdate);
        pouringTimeReal = updated.diff(firstOnJobSiteRealTime, 'minutes');
      }
    }
    const performance = pouringTimeReal - pouringTimePlanned;
    return {
      pouringTimeReal,
      pouringTimePlanned,
      performance,
    };
  }
}
